import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api-service/api.service';

@Component({
  selector: 'app-riparian-requests',
  templateUrl: './riparian-requests.component.html',
  styleUrls: ['./riparian-requests.component.css'],
})
export class RiparianRequestsComponent implements OnInit {
  isLoading = true;
  search = '';
  riparianParkingRequestData: any[] = [];
  dtOptions: DataTables.Settings = {};
  currentSortParam = 'createdAt|desc';

  constructor(
    private apiService: ApiService,
    private router: Router,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full',
      ordering: true,
      processing: true,
      serverSide: true,
      searching: true,
      search: true,
      rowCallback: (row: Node, data: any, index: number) => {
        const self = this;
        const detailsButton = $('td', row).find('.parking-request-details');
        $(detailsButton).off('click');
        $(detailsButton).on('click', () => {
          this.router.navigateByUrl('parking-request-details/' + data.id);
        });
        return row;
      },
      columns: [
        {
          title: 'Nume',
          data: 'firstName',
        },
        {
          title: 'Prenume',
          data: 'lastName',
        },
        {
          title: 'E-mail',
          data: 'email',
        },
        {
          title: 'Abonament',
          render: (data: any, type: any, row: any, meta: any) => {
            return row.subscriptionZoneName;
          },
        },
        {
          title: 'Data și ora',
          data: 'subscriptionRequestDate',
          render: (data: any, type: any, row: any, meta: any) => {
            const formattedDate = this.datePipe.transform(
              data,
              'dd-MM-yyyy, HH:mm:ss'
            );
            return formattedDate || '-';
          },
        },
        {
          title: 'Status',
          render: (data: any, type: any, row: any, meta: any) => {
            const statusName = this.getStatusNameByType(row.status);
            let statusColor = '';
            let fontWeight = '';

            switch (row.status) {
              case 'accepted':
                statusColor = 'green';
                break;
              case 'userActionNeeded':
                statusColor = 'black';
                fontWeight = 'bold';
                break;
              case 'pending':
                statusColor = 'black';
                fontWeight = 'bold';
                break;
              case 'rejected':
                statusColor = 'red';
                fontWeight = 'bold';
                break;
              case 'active':
                statusColor = 'blue';
                break;
              case 'expired':
                statusColor = 'red';
                break;
              default:
                statusColor = 'black';
                break;
            }

            return `<span style="color: ${statusColor}; font-weight: ${fontWeight}">${statusName}</span>`;
          },
        },
        {
          title: 'Detalii',
          render: (data: any, type: any, row: any, meta: any) => {
            return '<a class="parking-request-details" style="text-decoration: none; color:#4298B5; cursor: pointer">Detalii</a>';
          },
          orderable: false,
        },
      ],
      ajax: (data: any, callback, settings) => {
        this.isLoading = true;
        this.apiService
          .getAllParkingRequests(
            data.search.value,
            'riparian',
            data.length,
            data.start,
            this.currentSortParam
          )
          .subscribe(
            (response: any) => {
              this.riparianParkingRequestData = response.results.map(
                (row: any) => {
                  return {
                    firstName: row.requester.firstName || '-',
                    lastName: row.requester.lastName || '-',
                    email: row.requester.email || '-',
                    subscriptionRequestDate: row.createdAt,
                    subscriptionZoneName: row.subscriptionZone.zoneName,
                    subs: row.createdAt,
                    status: row.status || '-',
                    id: row.id,
                  };
                }
              );

              setTimeout(() => {
                callback({
                  draw: data.draw,
                  data: this.riparianParkingRequestData,
                  recordsTotal: response.total,
                  recordsFiltered: response.total,
                });
              }, 50);
            },
            (error: any) => {
              console.error('API Error:', error);
              this.isLoading = false;
            }
          );
      },

      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        },
      },
    };
  }

  getStatusNameByType(status: string): string {
    let name = '';

    switch (status) {
      case 'accepted':
        name = 'Acceptată';
        break;
      case 'userActionNeeded':
        name = 'În aşteptare documente';
        break;
      case 'pending':
        name = 'Cerere nouă';
        break;
      case 'rejected':
        name = 'Respinsă';
        break;
      case 'active':
        name = 'Activ';
        break;
      case 'expired':
        name = 'Expirat';
        break;
      default:
        break;
    }
    return name;
  }

  sortTable(columnName: string) {
    this.currentSortParam =
      this.currentSortParam === `${columnName}|asc`
        ? `${columnName}|desc`
        : `${columnName}|asc`;
  }
}
